var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './ProductPoster.scss';
import useElementSize from '../../Hooks/useElementSize';
import { useHistory } from 'react-router-dom';
import { ImagePlaceholder } from '../../Assets/ImagePlaceholder';
import InkyMageImg from '../../../Devon/Components/InkyMageImg/InkyMageImg';
var ProductPoster = function (_a) {
    var src = _a.src, alt = _a.alt, _b = _a.ratio, ratio = _b === void 0 ? 125 : _b, hover = _a.hover, _c = _a.s, s = _c === void 0 ? { width: 145 } : _c, m = _a.m, _d = _a.l, l = _d === void 0 ? { width: 288 } : _d, _e = _a.xl, xl = _e === void 0 ? { width: 405 } : _e, isOnSale = _a.isOnSale, isProductPage = _a.isProductPage, props = __rest(_a, ["src", "alt", "ratio", "hover", "s", "m", "l", "xl", "isOnSale", "isProductPage"]);
    var _f = __read(useElementSize(), 2), posterRef = _f[0], width = _f[1].width;
    var history = useHistory();
    return (_jsxs("div", { className: "ui-product-poster-container ".concat(hover !== false && 'ui-product-poster-container-hover'), style: { paddingTop: ratio + '%' }, onClick: function () {
            if (props.productId != undefined) {
                history.push('/product/' + props.readableLink);
            }
        }, children: [isOnSale && _jsx("span", { className: "on-sale ".concat(isProductPage ? 'on-sale-product-page' : ''), children: "ON SALE" }), _jsx("div", { className: 'ui-product-poster-container-2', children: _jsx("div", { className: 'ui-product-poster-wrapper', ref: posterRef, children: src ?
                        _jsx(InkyMageImg, { className: 'ui-product-poster-image', src: src, alt: alt, preloadImage: props.preloadImage, s: s, m: m, l: l, xl: xl, width: 1763, height: 2530 })
                        :
                            _jsx(ImagePlaceholder, { alt: alt }) }) })] }));
};
export default ProductPoster;
